import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { CustomHttp, ConfigServerService } from '../../../core';
import { UnidadeNegocioLinhaProducao, UnidadeNegocioLinhaProducaoFilter } from '../linha-producao';

@Injectable({
    providedIn: 'root'
})
export class UnidadeNegocioSearchesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/unidadenegocio`;
    }

    /** Pesquisa todos as linhas de produção vinculadas a unidade de negócio informada */
    searchLinhasProducao(idUnidadeNegocio: number, filter: UnidadeNegocioLinhaProducaoFilter): Observable<UnidadeNegocioLinhaProducao[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<UnidadeNegocioLinhaProducao[]>(`${this.pathApi}/${idUnidadeNegocio}/linhaproducao`, {params});
    }

    /** Obtem o formulário para os itens da cotação da unidade de negócio e linha de produção informados */
    getCotacaoItemFormulario(idUnidadeNegocio: number, idLinhaProducao: number): Observable<number> {
        return this.customHttp.get<number>(`${this.pathApi}/${idUnidadeNegocio}/linhaproducao/${idLinhaProducao}/cotacaoitemformulario`);
    }
}
